import { combineReducers } from 'redux';

import quizData from './slices/quiz/quizSlice';
import teacherData from './slices/teacher/teacherSlice';

export default combineReducers({
  teacher: teacherData,
  quizData: quizData,
});
